import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  width: "24",
  height: "20",
  viewBox: "0 0 24 20",
  fill: "none",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M19.8308 0.778273C20.7265 -0.19881 22.2446 -0.264817 23.2217 0.630842C24.1988 1.5265 24.2648 3.04466 23.3692 4.02174L10.1692 18.4217C9.18738 19.4928 7.48649 19.4526 6.55631 18.3364L0.556327 11.1364C-0.292224 10.1182 -0.154646 8.60481 0.863615 7.75626C1.88188 6.90771 3.39523 7.04529 4.24378 8.06355L8.4861 13.1543L19.8308 0.778273Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
const SuccessIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  SuccessIcon as default
};
//# sourceMappingURL=TickIcon.vue.es.js.map
